import React, {  Component } from 'react';
import { connect } from 'react-redux';

class ChangeDeliveryMethodYESForAlternateADCOverlayDialog extends Component {
    constructor(props) {
        super(props);
		this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog('ChangeDeliveryMethodYESForAlternateADCOverlayDialog');
    }
	componentDidMount() {
		// window.scrollTo(0, 0);
		this.setState({
            showDialog: this.props.showDialog
        });
	}
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="changeDeliveryMethodYESOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Change Shipping Method</h2>
                    <p>Your order doesn&#39;t have enough points to qualify for direct shipment.</p>
                    <p><b>Would you like to continue with ADC LTL? Additional charges may apply.</b></p>
                    <div className="noButtonContainer">
                        <a onClick={(e) => this.props.continueDeliveryWith(false, e)} href="" className="noButton blueButton">No</a>
                    </div>
                    <div className="yesButtonContainer">
                        <a className="yesButton blueButton" onClick={(e) => this.props.continueDeliveryWith("ADC LTL", e)}>Yes</a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

ChangeDeliveryMethodYESForAlternateADCOverlayDialog = connect(mapStateToProps)(ChangeDeliveryMethodYESForAlternateADCOverlayDialog);
export default ChangeDeliveryMethodYESForAlternateADCOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/changeDeliveryMethodYESForAlternateADCOverlayDialog.js